import type { VergeNavigationVariants } from "@voxmedia/duet-ui/components/navigation/Navigation/Navigation";

/**
 * Theme-enabled shells style subscribe chrome via GlobalStyles token overrides;
 * use the theme-contract `standard` variant. Fixed-palette shells use a legacy
 * light-nav variant instead.
 */
export function getSubscribeNavVariant(
  themeEnabled: boolean,
): VergeNavigationVariants {
  return themeEnabled ? "standard" : "verge-franklin";
}
